// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"485":"4cc21cb7","533":"db890f55"}[chunkId] + ".css";
};